/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import PropTypes from 'prop-types';
import { Button, ScrollToHelper } from 'sarsaparilla';
import StarDisplay from '../StarDisplay';

export default function RatingSummary({ aggregate, wrapper: Tag = 'div' }) {
    const handleScrollDown = () => {
        const el = document.getElementById(
            'rating-review-inventory-review-section-heading'
        );
        const header = document.getElementById('nav-header-container');
        if (!header || !el) return;
        const currentPosition = window.scrollY;
        const y = el.getBoundingClientRect().top - header.offsetHeight + currentPosition;
        ScrollToHelper.scrollToY(y);
        el.focus();
    };

    if (!aggregate || !aggregate.number_of_ratings) {
        return null;
    }
    return (
        <Tag className="ratReview-rating-summary-wrapper">
            <Button appearance="link" onClick={handleScrollDown}>
                <StarDisplay value={aggregate.average_rating} />
                <span className="ratview-star-value">
                    {`${aggregate.number_of_ratings} Review${aggregate.number_of_ratings > 1 ? 's' : ''}`}
                </span>
            </Button>
        </Tag>
    );
}

RatingSummary.propTypes = {
    aggregate: PropTypes.shape({
        location_id: PropTypes.string,
        average_rating: PropTypes.number,
        number_of_ratings: PropTypes.number,
        star_counts: PropTypes.shape({
            1: PropTypes.number,
            2: PropTypes.number,
            3: PropTypes.number,
            4: PropTypes.number,
            5: PropTypes.number,
        }),
        aggregate_cell_coverage_ratings: PropTypes.arrayOf(
            PropTypes.shape({
                carrier: PropTypes.string,
                average_rating: PropTypes.number,
                number_of_ratings: PropTypes.number,
            })
        ),
    }),
    wrapper: PropTypes.oneOf(['div', 'li']),
};
